const ikeaProxyRoute = '/ikea';

const convertRelativeUrl = (relativePath: string) => {
  return `${window.location.origin}${relativePath}`;
};

const getProxyUrl = (url: string, proxyRoute: string) => {
  const _url = new URL(url);
  return url.replace(_url.origin, `${window.location.origin}${proxyRoute}`);
};

const promiseScript = (url: string): Promise<any> =>
  new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.addEventListener('load', resolve);
    document.head.appendChild(script);
  });

export const loadTokenService = async (country: string, language: string) => {
  if (!['development', 'test'].includes(process.env.NODE_ENV)) {
    return Promise.reject(`Token service will not loaded, on ${process.env.NODE_ENV} environment.`);
  }

  const tokenUrl = getProxyUrl(
    `${window.location.origin}/${country}/${language}/token-service/token-service-fragment.html`,
    ikeaProxyRoute,
  );

  const tokenResponse = await fetch(tokenUrl);

  if (!tokenResponse.ok) {
    return Promise.reject('Token service could not be loaded.');
  }

  const scripts = await tokenResponse.text();
  const matches = scripts.matchAll(/src="(.*?)"/gim);
  return Promise.all(
    [...matches].map((match) => {
      const url = match[1].includes('//') ? match[1] : convertRelativeUrl(match[1]);
      if (/localhost|cte|ppe/.test(url)) {
        return promiseScript(getProxyUrl(url, ikeaProxyRoute));
      } else {
        return promiseScript(url);
      }
    }),
  );
};
